import React from 'react';
import { useScrollToView } from './useScrollToView';

/**
 * @typedef {object} PageProps
 * @property {React.ReactNode} [children]
 * @property {string} [title]
 * @property {string} [className]
 */

/**
 * @param {PageProps} props
 */
const Page = props => {
  const { children, title = '', className = '' } = props;

  const scrollToRef = useScrollToView();

  setDocumentTitle(title);

  return (
    <div className={'page ' + className} ref={scrollToRef}>
      <main>{children}</main>
    </div>
  );
};

const setDocumentTitle = title => {
  const pageTitle = 'VIP - ' + title;
  document.title = pageTitle;
};

export default Page;
